<template>
  
  <div class="text-center my-2 pa-0 d-flex flex-column align-center" >
    <span style="max-width: 350px;">
      <h1 class="mb-2" style="font-size: 19px;">
        Web Access Required
      </h1>
      
      <p class="pt-1 pb-2 font-weight-thin font-italic">To comply with app store policies, membership information is not accessible through the app.</p>
      <p class="pb-3 font-weight-thin" v-html="content"></p>
      <Button class="w-100" :slim="true" version="action" :label="btn_1_content" @click="EmailUserMembershipInfo()"/>
    </span>
  </div>
  
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';

import Button from '@/components/ComponentLibrary/Button.vue';
import { getWebAppUrl } from '@/services/admin_actions/apiUtils';
import { axiosLevelTech } from '@/services/axiosConfig';
import { showToast } from '@/services/notifications/toastService';

// Define emits for the component to communicate with parent components
const emit = defineEmits<{ (e: 'close'): void }>();

const btn_1_content = ref('Learn More');
const content = computed(() => {
  return "To remain in compliance with app store policies, you will be unable to access your membership information through the app. " +
  "You will be able to update your membership at " + getWebAppUrl('/membership') + " or contact our support team for assistance.";
});

// Computed property to check if the popup has a button & open in new tab
const EmailUserMembershipInfo = () => {
  axiosLevelTech.post('/api/email/EmailLinkToMembershipPage')
  .then(() => {
    // Handle success, e.g., show a success message or redirect
    console.log('Membership information emailed successfully.');
    // Show a toast or notification to inform the user
    showToast('success','Membership information has been emailed to you. Please check your inbox.', 50000);
    // Tell BottomSheet to close
    emit('close');
  })
  .catch((error) => {
    // Handle error, e.g., show an error message
    console.error('Error emailing membership information:', error);
  });
};


</script>

<style lang="scss">

</style>